import React, { useState } from 'react';

const StarRating = ({ 
  rating = 0, 
  averageRating = 0,
  totalRatings = 0,
  onRate, 
  readonly = false,
  size = 'md' 
}) => {
  const [hoverRating, setHoverRating] = useState(0);
  
  const sizeClasses = {
    xs: 'text-sm',
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  const handleClick = (value) => {
    if (!readonly && onRate) {
      onRate(value);
    }
  };

  const displayRating = hoverRating || rating || 0;

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center">
        {[1, 2, 3, 4, 5].map((star, index) => (
          <button
            key={star}
            type="button"
            disabled={readonly}
            onClick={() => handleClick(star)}
            onMouseEnter={() => !readonly && setHoverRating(star)}
            onMouseLeave={() => !readonly && setHoverRating(0)}
            className={`${sizeClasses[size]} transition-all duration-300 ${
              readonly ? 'cursor-default' : 'cursor-pointer hover:scale-125 hover:rotate-12'
            }`}
            style={{ transitionDelay: `${index * 30}ms` }}
          >
            {star <= displayRating ? (
              <span className="text-yellow-400 drop-shadow-[0_0_8px_rgba(250,204,21,0.5)]">★</span>
            ) : (
              <span className="text-gray-600 hover:text-gray-400">☆</span>
            )}
          </button>
        ))}
      </div>
      
      {/* Show average rating info */}
      {totalRatings > 0 && (
        <div className="text-xs text-gray-400 ml-1 animate-fade-in">
          <span className="text-yellow-400 font-bold">{averageRating.toFixed(1)}</span>
          <span className="ml-1">({totalRatings})</span>
        </div>
      )}
    </div>
  );
};

export default StarRating;
